import { render, staticRenderFns } from "./size-legend.vue?vue&type=template&id=4bfa1cd4"
import script from "./size-legend.vue?vue&type=script&lang=js"
export * from "./size-legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports